import {ENDPOINT_URL} from '../constants';
import getFetchOptions from '../utils/getFetchOptions';
import {apiErrorHandling} from '../utils/apiUtils';

const headers = new Headers();
headers.append('Content-Type', 'application/json');

export default function checktokenValidity(token) {
	return fetch(
		`${ENDPOINT_URL}/checktokenvalidity`,
		getFetchOptions({
			method: 'POST',
			body: JSON.stringify({token}),
		})
	)
		.then((response) => {
			if (!response.ok) {
				return response.json();
			}
			return response.json();
		})
		.catch((err) => {
			return Promise.reject(apiErrorHandling(err));
		});
}
